import React from 'react';
import { Form, DatePicker } from 'antd';
import moment from 'moment';
import { fieldNames } from './constants';
import useDebouncedFunc from '../../../../../../hooks/useDebounsedFunc';
import styles from './DocFormModal.module.scss';

const { Item: FormItem } = Form;

const disabledDate = (current) => {
  const today = moment().startOf('day');
  return current && current.clone().startOf('day').isBefore(today);
};

const FromDateField = ({ form, initialValue }) => {
  const { getFieldDecorator, getFieldValue, isFieldTouched, validateFields } =
    form;

  const debounceValidateToDate = useDebouncedFunc(() => {
    if (isFieldTouched(fieldNames.toDate)) {
      validateFields([fieldNames.toDate]);
    }
  }, 500);

  const compareToDateField = (_rule, value, callback) => {
    const toDate = getFieldValue(fieldNames.toDate)?.clone()?.startOf('day');
    const cloneVal = value?.clone()?.startOf('day');

    if (!toDate) {
      callback();
      return;
    }

    if (!cloneVal) {
      callback('Укажите дату публикации у собственника');
      return;
    }

    if (cloneVal.isAfter(toDate)) {
      callback('Дата публикации не может быть позже даты окончания');
      return;
    }

    callback();
  };

  const handleChange = () => {
    debounceValidateToDate();
  };

  return (
    <FormItem
      label="Дата публикации у собственника"
      colon={false}
    >
      {getFieldDecorator(fieldNames.fromDate, {
        initialValue: initialValue ? moment(initialValue) : moment(),
        rules: [
          { type: 'object', validator: compareToDateField },
          {
            required: true,
            message: 'Укажите дату',
          },
        ],
      })(
        <DatePicker
          className={styles.fullWidth}
          format="DD.MM.YYYY"
          disabledDate={disabledDate}
          onChange={handleChange}
          allowClear={false}
        />
      )}
    </FormItem>
  );
};

export default FromDateField;
